module.exports = __webpack_public_path__ + "img/logo.825a4d39.png";